import { render, staticRenderFns } from "./unitList.vue?vue&type=template&id=4ff1cd9d&scoped=true&"
import script from "./unitList.vue?vue&type=script&lang=js&"
export * from "./unitList.vue?vue&type=script&lang=js&"
import style0 from "./unitList.vue?vue&type=style&index=0&id=4ff1cd9d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1cd9d",
  null
  
)

export default component.exports